import { api } from "@/lib/api";

/**
 * Opens PayFast hosted checkout for a pending payable (booking / order / subscription).
 * Web: full-page redirect. PayFast returns the browser to the return_to URL.
 */
export async function startPayfastCheckout(refId, returnPath) {
  const returnTo = `${window.location.origin}${returnPath}`;
  const { checkout_url } = await api(`/payments/${refId}/session`, {
    method: "POST",
    body: { return_to: returnTo },
  });
  window.location.href = checkout_url;
}
